/* ═══════════════════════════════════════════════════════════════
   Time & Expense rebuild (Tranche 4) — Expenses CSV export
   (preserved exactly from the old TimeTrackingPage ExpensesPage).
   ═══════════════════════════════════════════════════════════════ */

import type { Expense, Project, ExpenseType } from '../../../shared/types';

export function exportExpensesCSV(args: {
  expenses: Expense[];
  projects: Project[];
  expenseTypes: ExpenseType[];
  memberId: string;
}) {
  const { expenses, projects, expenseTypes, memberId } = args;
  const rows: string[] = [];
  rows.push(
    ['Date', 'Project', 'Expense Type', 'Quantity', 'Rate', 'Total', 'Comment', 'Status'].join(',')
  );
  for (const exp of expenses) {
    const proj = projects.find((p) => p.id === exp.projectId);
    const et = expenseTypes.find((t) => t.id === exp.expenseTypeId);
    rows.push(
      [
        exp.date,
        `"${proj?.name || ''}"`,
        `"${et?.name || ''}"`,
        exp.quantity,
        exp.rate ?? '',
        exp.total.toFixed(2),
        `"${(exp.comment || '').replace(/"/g, '""')}"`,
        exp.status,
      ].join(',')
    );
  }
  const blob = new Blob([rows.join('\n')], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `expenses-${memberId}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
